import { waLink, WA_MESSAGES, trackWhatsApp } from "@/lib/whatsapp";
import WhatsAppIcon from "./WhatsAppIcon";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink(WA_MESSAGES.default)}
      onClick={() => trackWhatsApp("botao_flutuante")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Falar no WhatsApp"
      title="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] transition-[background-color,transform] duration-300 hover:scale-110 hover:bg-[#20BD5A]"
    >
      <WhatsAppIcon className="h-7 w-7" />
    </a>
  );
}
